import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  Table,
  TableBody,
  TableCell,
  TableColumn,
  TableHeader,
  TableRow,
  Pagination,
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Tabs,
  Tab,
  Card,
  CardBody,
  Chip,
  Divider,
} from "@nextui-org/react";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faFilter, 
  faEye, 
  faArrowsAltH, 
  faColumns, 
  faGripVertical,
  faSave,
  faTimes,
  faChartBar,
  faInfoCircle
} from "@fortawesome/free-solid-svg-icons";
import { capitalize, StringLimit } from "../../controllers/APIController";
import {
  DeleteOnedata,
  getDataWithFilterUrl,
} from "../../controllers/APIController";

import {
  CopyTableItem,
  DeleteTableItem,
  SearchInput,
} from "../../utils/helper";
import LoadingPage from "../../components/Loader/LoadingPage";
import BreadCrumbsPage from "../../components/BreadCrumbsPage";
import NullData from "../../components/ErrorPage/NullData";
import { StandardCancelButton, StandardDeleteButton } from "../../components/StandardButtons";

// Add CSS for line-clamp
const lineClampStyles = `
  .line-clamp-1 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  .line-clamp-2 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
`;

const MetricsBuilder = () => {
  const navigate = useNavigate();
  const { _orgId } = useParams();
  const [isLoading, setisLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);

  const [metrics, setMetrics] = useState([]);
  const [reRender, setReRender] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("");
  const [categories, setCategories] = useState([]);

  // Preview & Arrange state
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
  const [previewMode, setPreviewMode] = useState("preview");
  const [arrangedMetrics, setArrangedMetrics] = useState([]);
  const [layoutMode, setLayoutMode] = useState("grid");
  const [draggedItem, setDraggedItem] = useState(null);
  const [dragOverItem, setDragOverItem] = useState(null);

  // Delete confirmation modal state
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteItemData, setDeleteItemData] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteError, setDeleteError] = useState(null);

  const UserLogged = JSON.parse(sessionStorage.getItem("userData"));
  const userRole = UserLogged && UserLogged?.user?.userRole;



  const OrgInfo = UserLogged && UserLogged.user.LastOrgId;
  const orgFilterUrl = "filters[Organization][id][$eqi]=" + OrgInfo;



  const handleNavigate = () => {
    navigate(`/${_orgId}/metrics-builder/create`);
  };

  const deleteFormHandler = async (id) => {
    try {
      setIsDeleting(true);
      setDeleteError(null);
      console.log("Deleting metric with ID:", id);
      
      const result = await DeleteOnedata("metrics", id);
      console.log("Delete result:", result);
      
      if (result) {
        console.log("Metric deleted successfully");
        setReRender((pre) => !pre);
        setIsDeleteModalOpen(false);
        setDeleteItemData(null);
        // You could add a success toast here
      } else {
        throw new Error("Delete operation failed");
      }
    } catch (error) {
      console.error("Error deleting metric:", error);
      setDeleteError("Failed to delete metric. Please try again.");
      // You could add an error toast here
    } finally {
      setIsDeleting(false);
    }
  };

  const handleDeleteClick = (id, name) => {
    console.log("Delete button clicked for:", { id, name });
    console.log("User role for delete:", userRole);
    setDeleteItemData({ id, name });
    setIsDeleteModalOpen(true);
  };

  const createDuplicateHandler = (id) => {
    console.log("Duplicate button clicked for ID:", id);
    console.log("User role for duplicate:", userRole);
    navigate(`/${_orgId}/metrics-builder/create?id=${id}`);
  };

  // Preview & Arrange functions
  const openPreviewModal = () => {
    setArrangedMetrics([...metrics]);
    setIsPreviewModalOpen(true);
  };

  const closePreviewModal = () => {
    setIsPreviewModalOpen(false);
    setPreviewMode("preview");
    setLayoutMode("grid");
  };

  const handleDragStart = (e, index) => {
    setDraggedItem(index);
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    setDragOverItem(index);
  };

  const handleDrop = (e, index) => {
    e.preventDefault();
    if (draggedItem === null || draggedItem === index) return;

    const newArrangedMetrics = [...arrangedMetrics];
    const draggedMetric = newArrangedMetrics[draggedItem];
    
    // Remove dragged item
    newArrangedMetrics.splice(draggedItem, 1);
    
    // Insert at new position
    newArrangedMetrics.splice(index, 0, draggedMetric);
    
    setArrangedMetrics(newArrangedMetrics);
    setDraggedItem(null);
    setDragOverItem(null);
  };

  const handleDragEnd = () => {
    setDraggedItem(null);
    setDragOverItem(null);
  };

  const saveArrangement = () => {
    // Here you could save the arrangement to the backend
    console.log("Saving metric arrangement:", arrangedMetrics);
    closePreviewModal();
  };

  const resetArrangement = () => {
    setArrangedMetrics([...metrics]);
  };

  useEffect(() => {
    console.log("MetricsBuilder useEffect triggered");
    console.log("OrgInfo:", OrgInfo);
    console.log("orgFilterUrl:", orgFilterUrl);
    console.log("UserLogged:", UserLogged);
    
    if (!OrgInfo) {
      console.error("No organization ID found");
      setisLoading(false);
      return;
    }

    getDataWithFilterUrl("metrics", orgFilterUrl)
      .then((data) => {
        console.log("API response:", data);
        const list = data?.data || [];
        console.log("Metrics list:", list);
        
        if (list.length > 0) {
          list.sort((a, b) => {
            if (
              a?.attributes?.Name.trim().toLowerCase() <
              b?.attributes?.Name.trim().toLowerCase()
            ) {
              return -1;
            }
            if (
              a?.attributes?.Name.trim().toLowerCase() >
              b?.attributes?.Name.trim().toLowerCase()
            ) {
              return 1;
            }
            return 0;
          });
        }

        setMetrics(list);
        
        // Extract unique categories from metrics data
        const uniqueCategories = [...new Set(list.map(item => item?.attributes?.Category).filter(Boolean))];
        setCategories(uniqueCategories);
        
        setisLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching metrics:", err);
        setisLoading(false);
      });
  }, [reRender, orgFilterUrl]);

  // Inject CSS styles for line-clamp
  useEffect(() => {
    const styleElement = document.createElement('style');
    styleElement.textContent = lineClampStyles;
    document.head.appendChild(styleElement);

    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  const headers = [
    "Metric Name",
    "Category",
    "Recommended Frequency",
    "Description",
    "Actions",
  ];

  const handleNavigateToMetric = (id) => {
    navigate(`/${_orgId}/metrics-builder/${id}`);
  };

  // Handle filter selection changes
  const handleFilterSelection = (key) => {
    setSelectedFilter(key);
  };

  // Function to assign colors to categories
  const getCategoryColor = (category) => {
    const categoryColors = {
      'reference data': 'primary',
      'environment': 'success',
      'social': 'warning',
      'governance': 'danger',
      'vendor details': 'warning',
      'energy': 'success',
      'waste': 'warning',
      'water': 'primary',
      'emissions': 'danger',
      'biodiversity': 'success',
      'community': 'warning',
      'labor': 'primary',
      'human rights': 'danger',
      'ethics': 'secondary',
      'compliance': 'success',
      'risk management': 'warning',
      'transparency': 'primary'
    };
    
    return categoryColors[category.toLowerCase()] || 'default';
  };

  // Filter metrics based on the search term and selected filter
  const filteredMetrics = metrics.filter((item) => {
    const name = item?.attributes?.Name || "";
    const description = item?.attributes?.Description || "";
    const category = item?.attributes?.Category || "";
    const matchesSearchTerm =
      name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      description.toLowerCase().includes(searchTerm.toLowerCase()) ||
      category.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesFilter =
      selectedFilter === "" ||
      category.toLowerCase() === selectedFilter.toLowerCase();
    const isNotSurvey = category.toLowerCase() !== "survey";
    return matchesSearchTerm && matchesFilter && isNotSurvey;
  });

  const ItemPerPage = 20;
  const totalPage = Math.ceil(filteredMetrics.length / ItemPerPage);

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Page Header */}
      <div className="bg-white border-b border-slate-200 px-8 py-6 shadow-sm">
        <div className="flex items-center justify-between max-w-full">
          <div>
            <h1 className="text-2xl font-semibold text-neutral-900">Metrics Builder</h1>
            <p className="text-base text-neutral-600 mt-2">Create and manage ESG metrics for your organization</p>
          </div>
          <div className="flex items-center gap-4">
            <Button 
              color="primary" 
              className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 font-medium"
              size="sm"
              onClick={handleNavigate}
            >
              Create new metric
            </Button>
            <Button 
              color="primary" 
              className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 font-medium"
              size="sm"
              onClick={openPreviewModal}
            >
              Preview & Arrange
            </Button>
            {/* Test button to see if buttons work outside the table */}
            <button 
              onClick={() => console.log("Test button clicked!")}
                              className="p-2 bg-emerald-500 text-white rounded"
            >
              Test Button
            </button>
          </div>
        </div>
      </div>

      <BreadCrumbsPage>
        <div className="">


          {/* Metric Repository Section */}
          <div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden">
            <div className="px-8 py-6 border-b border-slate-200 bg-gradient-to-r from-slate-50 to-white">
              <h2 className="text-xl font-semibold text-slate-900 mb-2">Metric Repository</h2>
              <p className="text-sm text-slate-600">
                Browse and manage your organization's ESG metrics. Use search and filters to find specific metrics quickly.
              </p>
            </div>

            <div className="p-8">
              <div className="flex items-center justify-between mb-6">
                <SearchInput
                  searchText={searchTerm}
                  setSearchText={setSearchTerm}
                  placeholderText={"Search for any ESG metric"}
                />

                <Dropdown>
                  <DropdownTrigger>
                    <Button
                      size="sm"
                      endContent={<FontAwesomeIcon icon={faFilter} />}
                      variant="bordered"
                      className="text-slate-600 hover:text-slate-900 px-6 border-slate-300"
                    >
                      {selectedFilter?.length > 0
                        ? capitalize(selectedFilter)
                        : "Filter by Category"}
                    </Button>
                  </DropdownTrigger>
                  <DropdownMenu
                    aria-label="Dropdown Variants"
                    onAction={handleFilterSelection}
                    selectedKeys={new Set([selectedFilter])}
                    selectionMode="single"
                  >
                    <DropdownItem key="">Clear Filters</DropdownItem>
                    {categories.map((category, index) => (
                      <DropdownItem
                        key={category.toLowerCase()}
                        color={getCategoryColor(category)}
                        variant="flat"
                      >
                        {category}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              </div>
              
              <LoadingPage isLoading={isLoading} loadingText="Loading metrics...">
                <div className="mt-6">
                  <Table
                    removeWrapper
                    selectionMode="single"
                    aria-label="all-metrices-table"
                    classNames={{
                      th: "bg-slate-50 text-slate-700 font-semibold py-4 px-6",
                      td: "py-6 px-6",
                      table: "min-h-[400px]",
                    }}
                  >
                    <TableHeader>
                      {headers.map((header, headerIndex) => (
                        <TableColumn key={headerIndex} className="text-sm font-medium">
                          {header}
                        </TableColumn>
                      ))}
                    </TableHeader>
                    <TableBody
                      emptyContent={
                        <div className="py-16 text-center">
                          <NullData
                            title={`No metric found. Click on "create" to make a new metric`}
                          />
                        </div>
                      }
                    >
                      {filteredMetrics.map((item, index) => {
                        const lowerPageLimit = (currentPage - 1) * ItemPerPage;
                        const upperPageLimit = currentPage * ItemPerPage;
                        if (index < lowerPageLimit || index >= upperPageLimit)
                          return null;

                        return (
                          <TableRow
                            key={item.id}
                            className="hover:bg-slate-50 transition-colors duration-200"
                          >
                            <TableCell 
                              onClick={() => handleNavigateToMetric(item.id)}
                              className="cursor-pointer"
                            >
                              <div className="font-medium text-slate-900">
                                {StringLimit(item?.attributes?.Name, 50) || "--"}
                              </div>
                            </TableCell>
                            <TableCell 
                              onClick={() => handleNavigateToMetric(item.id)}
                              className="cursor-pointer"
                            >
                              <div className="text-slate-700">
                                {item?.attributes?.Category || "--"}
                              </div>
                            </TableCell>
                            <TableCell 
                              onClick={() => handleNavigateToMetric(item.id)}
                              className="cursor-pointer"
                            >
                              <div className="text-slate-700">
                                {item?.attributes?.Frequency || "--"}
                              </div>
                            </TableCell>
                            <TableCell 
                              onClick={() => handleNavigateToMetric(item.id)}
                              className="cursor-pointer"
                            >
                              <div className="text-slate-600 max-w-xs">
                                {(item.attributes.Description &&
                                  StringLimit(item?.attributes?.Description, 80)) ||
                                  "--"}
                              </div>
                            </TableCell>
                            <TableCell>
                              <div className="flex items-center gap-4">
                                <CopyTableItem
                                  userRole={userRole}
                                  copyHandler={createDuplicateHandler}
                                  item={item}
                                />
                                <DeleteTableItem
                                  userRole={userRole}
                                  deleteHandler={handleDeleteClick}
                                  item={item}
                                />
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </div>
                {filteredMetrics.length > 0 && (
                  <div className="w-full mt-10 flex items-center justify-center">
                    <Pagination
                      showControls
                      total={totalPage}
                      color="secondary"
                      page={currentPage}
                      onChange={setCurrentPage}
                      size="sm"
                    />
                  </div>
                )}
              </LoadingPage>
            </div>
          </div>
        </div>
      </BreadCrumbsPage>

      {/* Preview & Arrange Modal */}
      <Modal 
        isOpen={isPreviewModalOpen} 
        onOpenChange={setIsPreviewModalOpen}
        size="full"
        scrollBehavior="inside"
        classNames={{
          base: "max-w-[95vw] max-h-[95vh] m-4",
          body: "p-0",
        }}
      >
        <ModalContent>
          <ModalHeader className="flex items-center gap-3 bg-gradient-to-r from-emerald-50 to-white border-b border-emerald-200">
            <FontAwesomeIcon icon={faArrowsAltH} className="text-emerald-600 text-lg" />
            <div>
              <h2 className="text-xl font-semibold text-gray-800">Preview & Arrange Metrics</h2>
              <p className="text-sm text-gray-600">
                Preview your metrics, arrange their order, and view the structure all in one place
              </p>
            </div>
          </ModalHeader>
          <ModalBody className="p-0">
            <div className="p-6">
              {/* Tabs */}
              <Tabs 
                aria-label="Preview and arrangement options" 
                selectedKey={previewMode}
                onSelectionChange={setPreviewMode}
                variant="light"
                classNames={{
                  tabList: "gap-6 w-full relative rounded-none p-2 border-b border-divider",
                  cursor: "w-full bg-emerald-100",
                  tab: "max-w-fit px-2 h-12",
                  tabContent: "group-data-[selected=true]:text-emerald-700"
                }}
              >
                <Tab key="preview" title="Metrics Preview">
                  <div className="mt-6">
                    <div className="flex items-center gap-4 mb-6">
                      <div className="flex items-center gap-2">
                        <FontAwesomeIcon icon={faEye} className="text-emerald-600" />
                        {/* <span className="font-medium">Layout Mode:</span> */}
                      </div>
                      <div className="flex gap-2">
                        <Button
                          size="sm"
                          variant={layoutMode === "grid" ? "solid" : "bordered"}
                          color={layoutMode === "grid" ? "primary" : "default"}
                          onPress={() => setLayoutMode("grid")}
                          startContent={<FontAwesomeIcon icon={faColumns} />}
                        >
                          Grid Layout
                        </Button>
                        <Button
                          size="sm"
                          variant={layoutMode === "list" ? "solid" : "bordered"}
                          color={layoutMode === "list" ? "primary" : "default"}
                          onPress={() => setLayoutMode("list")}
                          startContent={<FontAwesomeIcon icon={faChartBar} />}
                        >
                          List Layout
                        </Button>
                      </div>
                    </div>

                    {/* Metrics Preview */}
                    <div className={`${layoutMode === "grid" ? "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" : "space-y-4"}`}>
                      {arrangedMetrics.map((metric, index) => (
                        <Card 
                          key={metric.id} 
                          className="border border-gray-200 hover:border-emerald-300 transition-colors duration-200"
                        >
                          <CardBody className="p-4">
                            <div className="flex items-start justify-between mb-3">
                              <div className="flex items-center gap-2">
                                <Chip 
                                  size="sm" 
                                  color={getCategoryColor(metric?.attributes?.Category)}
                                  variant="flat"
                                >
                                  #{index + 1}
                                </Chip>
                                <Chip 
                                  size="sm" 
                                  color={getCategoryColor(metric?.attributes?.Category)}
                                  variant="flat"
                                >
                                  {metric?.attributes?.Category || "Uncategorized"}
                                </Chip>
                              </div>
                              <FontAwesomeIcon 
                                icon={faInfoCircle} 
                                className="text-gray-400 text-sm cursor-pointer hover:text-gray-600" 
                              />
                            </div>
                            <h3 className="font-semibold text-gray-900 mb-2 line-clamp-2">
                              {metric?.attributes?.Name || "Unnamed Metric"}
                            </h3>
                            <p className="text-sm text-gray-600 mb-3 line-clamp-2">
                              {metric?.attributes?.Description || "No description available"}
                            </p>
                            <div className="flex items-center justify-between text-xs text-gray-500">
                                                                   <span>Recommended Frequency: {metric?.attributes?.Frequency || "Not set"}</span>
                              <span>ID: {metric.id}</span>
                            </div>
                          </CardBody>
                        </Card>
                      ))}
                    </div>
                  </div>
                </Tab>
                
                <Tab key="arrange" title="Arrange Metrics">
                  <div className="mt-6">
                    <div className="flex items-center justify-between mb-6">
                      <div className="flex items-center gap-2">
                        <FontAwesomeIcon icon={faArrowsAltH} className="text-emerald-600" />
                        <span className="font-medium">Drag and drop metrics to reorder them</span>
                      </div>
                      <Button
                        size="sm"
                        variant="bordered"
                        onPress={resetArrangement}
                        className="text-emerald-700 border-emerald-300 hover:border-emerald-400"
                      >
                        Reset Order
                      </Button>
                    </div>

                    {/* Draggable Metrics List */}
                    <div className="space-y-3">
                      {arrangedMetrics.map((metric, index) => (
                        <div
                          key={metric.id}
                          draggable
                          onDragStart={(e) => handleDragStart(e, index)}
                          onDragOver={(e) => handleDragOver(e, index)}
                          onDrop={(e) => handleDrop(e, index)}
                          onDragEnd={handleDragEnd}
                          className={`
                            flex items-center gap-4 p-4 bg-white border-2 rounded-lg cursor-move transition-all duration-200
                            ${draggedItem === index ? 'border-emerald-400 bg-emerald-50 scale-105' : 'border-gray-200 hover:border-emerald-300'}
                            ${dragOverItem === index ? 'border-dashed border-emerald-500 bg-emerald-50' : ''}
                          `}
                        >
                          <div className="flex items-center gap-3">
                            <FontAwesomeIcon 
                              icon={faGripVertical} 
                              className="text-gray-400 cursor-move hover:text-gray-600" 
                            />
                            <Chip 
                              size="sm" 
                              color={getCategoryColor(metric?.attributes?.Category)}
                              variant="flat"
                            >
                              #{index + 1}
                            </Chip>
                          </div>
                          <div className="flex-1">
                            <h3 className="font-semibold text-gray-900">
                              {metric?.attributes?.Name || "Unnamed Metric"}
                            </h3>
                            <p className="text-sm text-gray-600 line-clamp-1">
                              {metric?.attributes?.Description || "No description available"}
                            </p>
                          </div>
                          <div className="flex items-center gap-2">
                            <Chip 
                              size="sm" 
                              color={getCategoryColor(metric?.attributes?.Category)}
                              variant="flat"
                            >
                              {metric?.attributes?.Category || "Uncategorized"}
                            </Chip>
                            <span className="text-xs text-gray-500">
                                                             {metric?.attributes?.Frequency || "No recommended frequency"}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Instructions */}
                    <div className="bg-emerald-50 p-4 rounded-lg mt-6">
                      <h5 className="font-medium text-emerald-800 mb-2">How to arrange metrics:</h5>
                      <ul className="text-sm text-emerald-700 space-y-1">
                        <li>• Drag metrics using the grip handle to reorder them</li>
                        <li>• The order you set here will be reflected in the metrics list</li>
                        <li>• Use the Preview tab to see how your arrangement looks</li>
                        <li>• Click "Reset Order" to restore the original arrangement</li>
                      </ul>
                    </div>
                  </div>
                </Tab>

                <Tab key="structure" title="Metrics Structure">
                  <div className="mt-6">
                    <div className="bg-gray-50 p-6 rounded-lg">
                      <h3 className="text-lg font-semibold text-gray-800 mb-4">Metrics Overview</h3>
                      
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        <Card className="bg-white">
                          <CardBody className="p-4">
                            <div className="text-center">
                              <div className="text-2xl font-bold text-emerald-600">{arrangedMetrics.length}</div>
                              <div className="text-sm text-gray-600">Total Metrics</div>
                            </div>
                          </CardBody>
                        </Card>
                        
                        <Card className="bg-white">
                          <CardBody className="p-4">
                            <div className="text-center">
                              <div className="text-2xl font-bold text-emerald-600">
                                {[...new Set(arrangedMetrics.map(m => m?.attributes?.Category).filter(Boolean))].length}
                              </div>
                              <div className="text-sm text-gray-600">Categories</div>
                            </div>
                          </CardBody>
                        </Card>
                        
                        <Card className="bg-white">
                          <CardBody className="p-4">
                            <div className="text-center">
                              <div className="text-2xl font-bold text-purple-600">
                                {arrangedMetrics.filter(m => m?.attributes?.Frequency).length}
                              </div>
                                                             <div className="text-sm text-gray-600">With Recommended Frequency</div>
                            </div>
                          </CardBody>
                        </Card>
                      </div>

                      <Divider className="my-6" />

                      <div className="space-y-4">
                        <h4 className="font-medium text-gray-800">Category Breakdown</h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                          {Object.entries(
                            arrangedMetrics.reduce((acc, metric) => {
                              const category = metric?.attributes?.Category || 'Uncategorized';
                              acc[category] = (acc[category] || 0) + 1;
                              return acc;
                            }, {})
                          ).map(([category, count]) => (
                            <div key={category} className="flex items-center justify-between p-3 bg-white rounded-lg border">
                              <span className="font-medium text-gray-700">{category}</span>
                              <Chip size="sm" color={getCategoryColor(category)} variant="flat">
                                {count} metrics
                              </Chip>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </div>
          </ModalBody>
          <ModalFooter className="border-t border-gray-200 bg-gray-50">
            <div className="flex items-center justify-between w-full">
              <div className="text-sm text-gray-600">
                {previewMode === "arrange" && (
                  <span>Drag and drop to reorder your metrics</span>
                )}
                {previewMode === "preview" && (
                  <span>Preview your metrics in different layouts</span>
                )}
                {previewMode === "structure" && (
                  <span>View metrics statistics and category breakdown</span>
                )}
              </div>
              <div className="flex items-center gap-3">
                <Button
                  variant="bordered"
                  onPress={closePreviewModal}
                  className="px-6"
                >
                  Close
                </Button>
                {previewMode === "arrange" && (
                  <Button
                    color="primary"
                    onPress={saveArrangement}
                    startContent={<FontAwesomeIcon icon={faSave} />}
                    className="bg-emerald-600 hover:bg-emerald-700 text-white px-6"
                  >
                    Save Arrangement
                  </Button>
                )}
              </div>
            </div>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal
        isOpen={isDeleteModalOpen}
        onOpenChange={setIsDeleteModalOpen}
        placement="top-center"
        classNames={{
          base: "max-w-sm",
          body: "p-0",
        }}
      >
        <ModalContent>
          <ModalHeader className="flex flex-col gap-1">
            <div className="flex items-center gap-2">
              <FontAwesomeIcon icon={faTimes} className="text-red-500 text-lg" />
              <h3 className="text-lg font-semibold text-gray-800">Confirm Deletion</h3>
            </div>
            <p className="text-sm text-gray-600">
              Are you sure you want to delete the metric "{deleteItemData?.name}"? This action cannot be undone.
            </p>
          </ModalHeader>
          <ModalBody>
            {deleteError && (
              <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                <p className="text-sm text-red-600">{deleteError}</p>
              </div>
            )}
            <div className="flex justify-end gap-2">
              <StandardCancelButton
                onPress={() => {
                  setIsDeleteModalOpen(false);
                  setDeleteError(null);
                }}
                isDisabled={isDeleting}
              >
                Cancel
              </StandardCancelButton>
              <StandardDeleteButton
                onPress={() => deleteFormHandler(deleteItemData?.id)}
                isLoading={isDeleting}
              >
                {isDeleting ? "Deleting..." : "Delete"}
              </StandardDeleteButton>
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default MetricsBuilder;
